import apiConfig from "./apiConfig";

export const certificateData = (_id) => {
    return apiConfig.get(`/certificate/${_id}`);
}